import { createContext, useContext, useState, useEffect } from "react";
import { translations, languages, getDefaultLanguage, setLanguage as saveLanguage, t as translate } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getDefaultLanguage());

  const setLanguage = (code) => {
    saveLanguage(code);
    setLanguageState(code);
  };

  // Translation function that uses current language
  const t = (path) => translate(path, language);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages, translations }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}

export default LanguageContext;
